const PageInfo = ({ page, perPage, itemTotal }: Props) => {
  return (
    <p>{`Showing ${(page - 1) * perPage + 1} to ${
      page * perPage > itemTotal ? itemTotal : page * perPage
    } of ${itemTotal}`}</p>
  )
}

type Props = {
  page: number
  perPage: number
  itemTotal: number
}

export default PageInfo
